import React from "react";

import { DismissiblePopup } from "./DismissiblePopup";

import { useFormBuildingCoachEnabled } from "../hooks/useFormBuildingCoachEnabled";

import { useAskPerformYardStore } from "../AskPerformYardStore";

export const FormBuildingCoachPopup: React.FC = () => {
	const formBuildingCoachEnabled = useFormBuildingCoachEnabled();
	const isOnFormBuilderPage = useAskPerformYardStore((state) => state.isOnFormBuilderPage);
	const isOpen = useAskPerformYardStore((state) => state.isOpen);

	return (
		<DismissiblePopup
			popupKey="form-building-coach"
			enabled={formBuildingCoachEnabled && isOnFormBuilderPage && !isOpen}
			title="Want help with questions or feedback on your form? Ask PerformYard can help!"
		/>
	);
};

export default FormBuildingCoachPopup;
